import { InjectionToken } from '@angular/core';

import { PhOverlayData } from './overlay.interface';

export const PH_OVERLAY_DATA = new InjectionToken<PhOverlayData>('PH_OVERLAY_DATA');
